import { authHeader } from './auth-header'
import axiosInstance from "./client"

export const cashboxService = {
  getAll,
  createOrUpdate,
  getById,
  deleteById,
}

function getById(cashboxId) {
  const requestOptions = {
    url: '/api/v1/user/cashbox/' + cashboxId,
    method: 'GET',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}

function getAll() {
  const requestOptions = {
    url: '/api/v1/user/cashbox',
    method: 'GET',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}


function createOrUpdate(jsonData) {
  let formData = new FormData()

  for (var key in jsonData) {
    if (jsonData[key] != null)
      formData.append(key, jsonData[key])
  }
  let rMethod = jsonData["id"] != null ? "PUT" : "POST"
  const requestOptions = {
    url: '/api/v1/user/cashbox',
    method: rMethod,
    data: formData,
    headers: authHeader()
  }

  return axiosInstance(requestOptions)
}


function deleteById(id) {
  const requestOptions = {
    url: `/api/v1/user/cashbox/` + id,
    method: 'DELETE',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}

